import React from "react";

class Paper extends React.Component {
  constructor(props) {
    window.location.replace(
      "https://storage.googleapis.com/sikwati-bucket/sikwati/pagaduan_thesis_manuscript.pdf"
    );
  }
}

export default Paper;
